// extracted by mini-css-extract-plugin
export default {"NoticeShowPage__Card":"NoticeShowPage_NoticeShowPage__Card__fyqY6","NoticeShowPage__BackToPage":"NoticeShowPage_NoticeShowPage__BackToPage__BjuG+"};